/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.17.0
 */
import { RoutePath } from '../../routes/constants/routesConstants';


export const CORPORATE_PAGE_PORTAL_ID = 'corporate-page-portal';
export const CORPORATE_PAGE_FOOTER_PORTAL_ID = 'corporate-page-footer-portal';

export const pagesWithBanner = [
    RoutePath.account,
    RoutePath.accountInfo,
    RoutePath.autoReportId,
    RoutePath.bills,
    RoutePath.billsUnpaid,
    RoutePath.campaigns,
    RoutePath.campaignsAccount,
    RoutePath.campaignsSubscriber,
    RoutePath.campaignInfo,
    RoutePath.dashboard,
    RoutePath.expensesAnalyzerAccount,
    RoutePath.expensesAnalyzerAccountId,
    RoutePath.expensesAnalyzerBillsAccounts,
    RoutePath.expensesAnalyzerBillsAccountId,
    RoutePath.expensesAnalyzerBillsAccountsSubscribers,
    RoutePath.expensesAnalyzerBillsAccountIdSubscribers,
    RoutePath.expensesAnalyzerBillsUnpaidAccounts,
    RoutePath.expensesAnalyzerBillsUnpaidAccountId,
    RoutePath.expensesAnalyzerBillsUnpaidAccountsSubscribers,
    RoutePath.expensesAnalyzerBillsUnpaidAccountIdSubscribers,
    RoutePath.expensesAnalyzerAccountSubscribers,
    RoutePath.expensesAnalyzerSubscriberFixed,
    RoutePath.expensesAnalyzerSubscriberFixedId,
    RoutePath.expensesAnalyzerSubscriberMobile,
    RoutePath.expensesAnalyzerSubscriberMobileId,
    RoutePath.inquiries,
    RoutePath.inquiryInfo,
    RoutePath.orders,
    RoutePath.orderId,
    RoutePath.settingsAutoReports,
    RoutePath.settingsLabels,
    RoutePath.settingsPositions,
    RoutePath.settingsProfile,
    RoutePath.settingsStatistics,
    RoutePath.subscriberFixed,
    RoutePath.subscriberId,
    RoutePath.subscriberMobile,
    RoutePath.wizardImportPersonalData,
    RoutePath.wizardMultiSearch,
    RoutePath.news,
];

// for child routes (in sub tab for example)
export const pageWithoutCorporateHelp = [
    RoutePath.autoReportIdAccountsEdit,
    RoutePath.autoReportIdSubscribersEdit,
].map(r => r.replace(/:[^/]*/, '(.*)'));
